module.exports = __webpack_public_path__ + "img/bg_pno_how.3d0b6ff2.jpg";